//@flow
import {makeStyles} from '@material-ui/core/styles';
import React, {useState} from 'react';
import {IconButton, InputBase} from '@material-ui/core';
import {useHistory, useLocation} from 'react-router-dom';
import queryString from 'query-string';
import {Clear} from '@material-ui/icons';
import {colors} from '../../assets/styles/colors';

import searchIcon from '../../assets/img/searchIcon.png';
import PropTypes from 'prop-types';

type Props = {
  mobile?: boolean,
  placeholder?: string,
  color?: string,
  maxWidth?: number,
  border?: string,
  borderRadius?: string,
  radius?: number,
  disabled?: boolean,
  externalHandleSearch?: (searchString?: string) => void,
};

const useStyles = props =>
  makeStyles(theme => ({
    searchInputWrapper: {
      /*       [theme.breakpoints.down('sm')]: {
        display: 'none',
        visibility: 'hidden',
      }, */
      // marginLeft: 'auto',
      // paddingRight: '30px',
      position: 'relative',
    },
    searchInputWrapperSM: {
      marginTop: theme.spacing(3),
      [theme.breakpoints.down('xs')]: {
        marginTop: theme.spacing(2),
      },
    },
    searchInput: {
      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },
      borderRadius: props.borderRadius || '20px',
      background:
        props.mobile || props.color === 'light'
          ? colors.grey200
          : props.color || colors.grey300,
      border: props.border || 'none',
      outline: 'none',
      height: 40,
      width: props.maxWidth ? props.maxWidth : '100%',
      fontSize: 'medium',
      lineHeight: 'normal',
    },
  }));

export default function SearchBar(props: Props) {
  const {mobile = false, placeholder, externalHandleSearch, disabled} = props;

  const classes = useStyles(props)();
  const location = useLocation();
  const history = useHistory();

  const getSearchFromQuery = (search: string) => {
    const s = queryString.parse(search);
    return s;
  };
  const query = getSearchFromQuery(location.search) || '';
  const [searchString, setSearchString] = useState(query.name || '');

  const handleSearchInputChange = e => {
    setSearchString(e.target.value);
  };

  // const handleSearchClear = e => {
  //   setSearchString('');
  //   history.push(`/`);
  // };

  const handleSearchClear = e => {
    e.preventDefault();
    setSearchString('');
    if (externalHandleSearch) {
      externalHandleSearch('');
    } else {
      delete query.name;
      history.push({search: queryString.stringify(query)});
    }
  };

  const handleSearch = e => {
    e.preventDefault();
    if (externalHandleSearch) {
      if (typeof searchString === 'string') externalHandleSearch(searchString);
    } else {
      // if (!searchString || typeof searchString !== 'string') {
      //   history.push(`/`);
      // } else {
      //   history.push(`/?search=${searchString}`);
      // }

      // console.log(query);
      delete query.name;
      // console.log(query);
      if (searchString) query.name = searchString;
      // console.log(query);
      history.push({search: queryString.stringify(query)});
    }
  };

  if (disabled) {
    return null;
  }

  return (
    <div
      className={
        mobile ? classes.searchInputWrapperSM : classes.searchInputWrapper
      }
    >
      <form onSubmit={handleSearch}>
        <InputBase
          className={classes.searchInput}
          startAdornment={
            <IconButton className={classes.searchIcon} onClick={handleSearch}>
              <img src={searchIcon} alt="" />
            </IconButton>
          }
          disabled={disabled}
          value={searchString}
          placeholder={placeholder}
          type="text"
          onChange={handleSearchInputChange}
          endAdornment={
            searchString && (
              <IconButton
                className={classes.searchClear}
                onClick={handleSearchClear}
              >
                <Clear />
              </IconButton>
            )
          }
        />
      </form>
    </div>
  );
}

SearchBar.propTypes = {
  mobile: PropTypes.bool,
  placeholder: PropTypes.string,
  color: PropTypes.string,
  maxWidth: PropTypes.number,
  border: PropTypes.string,
  borderRadius: PropTypes.string,
  externalHandleSearch: PropTypes.func,
};
